import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { makeRequest } from '@app/utils';

export const useResetPinStep1Mutation = (): UseMutationResult<
  unknown,
  unknown,
  { barcode: string }
> =>
  useMutation(['resetPinStep1'], barcode =>
    makeRequest({
      url: '/opac-users/reset-pin',
      method: 'POST',
      data: { barcode },
    })
  );

export const useResetPinStep2Mutation = (): UseMutationResult<
  unknown,
  unknown,
  {
    pin: string;
    token: string;
  }
> =>
  useMutation(['resetPinStep2'], ({ pin, token }) =>
    makeRequest({
      url: '/opac-users/patron-pin',
      method: 'POST',
      data: { pin },
      headers: { 'X-Okapi-Token': token },
    })
  );

export const useValidateBarcodeMutation = (): UseMutationResult<
  unknown,
  unknown,
  string
> =>
  useMutation(['validateBarcode'], token =>
    makeRequest({
      url: '/opac-auth/credential-reset-action/validate',
      method: 'POST',
      headers: { 'X-Okapi-Token': token },
    })
  );
